<template>
  <div style="position: relative">
    <b-sidebar
      id="sidebar-produto-fields"
      title="Informações visíveis"
      backdrop-variant="dark"
      backdrop
      right
      shadow
    >
      <div class="px-2 py-2">
        <div style="width: 100%" class="p-2">
          <h4 class="text-dark">Colunas customizadas</h4>
          <p>
            Selecione abaixo quais colunas deseja que estejam visíveis na
            listagem de produtos. Arraste para definir a ordem.
          </p>
        </div>
        <div
          style="width: 100%; max-height: 100%; overflow-y: scroll"
          class="mb-2"
        >
          <draggable
            v-model="localFields"
            handle=".drag-handle"
            :animation="150"
            ghost-class="drag-ghost"
          >
            <div
              v-for="field in localFields"
              :key="field.field"
              class="column-custom-item mb-0 ml-1 mr-1 p-1 rounded"
            >
              <div style="display: flex; align-items: center; gap: 10px">
                <span
                  class="drag-handle"
                  style="cursor: grab"
                  title="Arraste para reordenar"
                >
                  <DragVertical :size="20" class="text-muted" />
                </span>
                <span
                  class="switch switch-icon"
                  :class="{ 'switch-disabled': isFieldRequired(field) }"
                >
                  <label>
                    <input
                      type="checkbox"
                      :disabled="isFieldRequired(field)"
                      @change="
                        (e) =>
                          handleSelectFieldToShow(e.target.checked, field.field)
                      "
                      :checked="isFieldShow(field.field)"
                    />
                    <span></span>
                  </label>
                </span>
                <label
                  :for="field.label"
                  class="mb-0"
                  :class="{
                    'text-muted font-weight-bold': isFieldRequired(field),
                  }"
                >
                  {{ field.label }}
                </label>
              </div>
            </div>
          </draggable>
        </div>
      </div>
      <template #footer="{ hide }">
        <div class="d-flex text-light align-items-center px-3 py-2">
          <button
            style="width: 100%"
            ref="salvarFields"
            class="btn btn-primary btn-hover-dark font-weight-bold"
            @click="handleSaveFields"
          >
            Salvar
          </button>
        </div>
      </template>
    </b-sidebar>

    <b-sidebar
      id="sidebar-arquivo-balanca"
      title="Gerar arquivo"
      backdrop-variant="dark"
      backdrop
      right
      shadow
    >
      <div class="px-2 py-2">
        <div style="width: 100%" class="p-2">
          <h4 class="text-dark">Gerar arquivo</h4>
          <p>Selecione o modelo da balança:</p>
        </div>
        <div
          style="width: 100%; max-height: 100%; overflow-y: scroll"
          class="mb-2"
        >
          <b-col md="12">
            <b-form-group label="Modelo" label-for="modeloBalanca">
              <select
                name="modeloBalanca"
                id="modeloBalanca"
                v-model="modeloBalanca"
                class="form-control"
              >
                <option
                  v-for="(b, index) in balancas"
                  :value="b.id"
                  :key="'modelo' + index"
                >
                  {{ b.descricao }}
                </option>
              </select>
            </b-form-group>
          </b-col>
        </div>
      </div>
      <template #footer="{ hide }">
        <div class="d-flex text-light align-items-center px-3 py-2">
          <button
            style="width: 100%"
            ref="gerarTXT"
            class="btn btn-primary btn-hover-dark font-weight-bold"
            @click="gerarArquivoTxt"
          >
            Gerar
          </button>
        </div>
      </template>
    </b-sidebar>

    <FilterFields
      :fields="[
        {
          type: 'number',
          label: 'Código',
          field: 'codigo',
        },
        {
          type: 'text',
          label: 'Descrição',
          field: 'descricao',
        },
        {
          type: 'text',
          label: 'Fornecedor',
          field: 'fornecedor',
        },
        {
          type: 'text',
          label: 'Grupo',
          field: 'id_grupo',
        },
        {
          type: 'number',
          label: 'Cod. Barras',
          field: 'cod_barras',
        },
        {
          type: 'text',
          label: 'Referência',
          field: 'referencia',
        },
        {
          type: 'number',
          label: 'N. Compra',
          field: 'numero_ultima_compra',
        },
        {
          type: 'number',
          label: 'Custo',
          field: 'custo',
        },
        {
          type: 'number',
          label: 'Preço',
          field: 'preco',
        },
        {
          type: 'text',
          label: 'Obs',
          field: 'obs',
        },
        {
          type: 'text',
          label: 'Descrição Comple.',
          field: 'desc_complementar',
        },
        {
          type: 'text',
          label: 'Marca',
          field: 'marca',
        },
        {
          type: 'text',
          label: 'Tributação',
          field: 'id_tributacao',
        },
        {
          type: 'text',
          label: 'Perfil Tributário',
          field: 'id_perfil_tributario',
        },
        {
          type: 'text',
          label: 'CFOP',
          field: 'cfop',
        },
        {
          type: 'text',
          label: 'CST/CSOSN',
          field: 'cstCsosn',
        },
        {
          type: 'select',
          label: 'Tipo',
          field: 'tipo',
          options: [
            'Todos',
            'Mercadoria para Revenda',
            'Matéria-Prima',
            'Embalagem',
            'Produto em processo',
            'Produto Acabado',
            'Subproduto',
            'Material uso e consumo',
            'Ativo Imobilizado',
            'Outros',
          ],
        },
        {
          type: 'select',
          label: 'Status',
          field: 'status',
          options: ['Ativo', 'Inativo'],
        },
        {
          type: 'select',
          label: 'Quantidade',
          field: 'quantidade',
          options: ['Negativos', 'Positivos', 'Zerados'],
        },
      ]"
    />

    <b-dropdown
      id="menu"
      variant="dark"
      v-b-tooltip.hover.top="'Mais ações'"
      style="position: absolute; top: 0; left: 50px"
    >
      <template #button-content>
        <Menu :size="18" />
      </template>
      <b-dropdown-item
        v-b-modal.duplicarProduto
        :disabled="
          !actionsStore.selectedRows.length ||
          actionsStore.selectedRows.length > 1
        "
        >Duplicar produto</b-dropdown-item
      >
      <b-dropdown-item
        @click="
          () =>
            getRequestAdmin(() => {
              $bvModal.show('excluirProdutos');
            })
        "
        :disabled="!actionsStore.selectedRows.length"
        >Excluir produto(s)
      </b-dropdown-item>
      <b-dropdown-item
        @click="
          () =>
            getRequestAdmin(() => {
              $bvModal.show('reajustePreco');
            })
        "
        >Reajuste de Preço
      </b-dropdown-item>
      <b-dropdown-item
        @click="
          () =>
            getRequestAdmin(() => {
              abrirModalReplicarCampo();
            })
        "
        >Manutenção de produtos
      </b-dropdown-item>
      <b-dropdown-item
        @click="
          () =>
            getRequestAdmin(() => {
              $bvModal.show('produtosPesados');
            })
        "
        >Gerar código de barras (Produtos Pesados)
      </b-dropdown-item>
    </b-dropdown>

    <b-button
      class="border border-muted"
      v-b-toggle.sidebar-produto-fields
      variant="secondary"
      v-b-tooltip.hover.top="'Customizar colunas'"
      style="position: absolute; right: 0; top: 0"
    >
      <ToggleSwitchOutline :size="20" />
    </b-button>

    <b-button
      class="border border-muted"
      variant="secondary"
      v-b-tooltip.hover.top="'Lista de preço'"
      @click="$router.push({ name: 'lista' })"
      style="position: absolute; right: 150px; top: 0"
    >
      <MoneySymbol :size="20" />
    </b-button>

    <b-button
      class="border border-muted"
      variant="secondary"
      v-b-tooltip.hover.top="'Ajuste manual de estoque'"
      @click="abrirModalAjusteEstoque"
      style="position: absolute; right: 200px; top: 0"
    >
      <PackageVariantClosed :size="20" />
    </b-button>

    <b-button
      class="border border-muted"
      variant="secondary"
      v-b-tooltip.hover.top="'Terminal de consulta'"
      @click="abrirTerminalConsulta"
      style="position: absolute; right: 50px; top: 0"
    >
      <BarcodeScan :size="20" />
    </b-button>

    <b-button
      class="border border-muted"
      v-b-toggle.sidebar-arquivo-balanca
      variant="secondary"
      v-b-tooltip.hover.top="
        'Gerar arquivo .txt para carga nas balanças (Produtos Pesados)'
      "
      style="position: absolute; right: 100px; top: 0"
    >
      <Balence :size="20" />
    </b-button>

    <b-modal
      id="excluirProdutos"
      title="Deseja excluir todos os produtos selecionados?"
      centered
      size="xs"
    >
      <div class="d-flex">
        <p>
          Somente será possível excluir um produto, se não houver nenhum tipo de
          movimentação para o produto.
        </p>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="excluirProduto"
            ref="excluirProdutos"
            class="mr-5"
          >
            Excluir
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="produtosPesados"
      title="Deseja gerar para todos produtos pesados do seu estoque o código de barras?"
      centered
      size="xs"
    >
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="gerarCodigoBarraPesado"
            ref="gerarCodigoBarra"
            class="mr-5"
          >
            Gerar
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="reajustePreco"
      title="Ajuste de preço com base no percentual (%) informado"
      centered
      size="xs"
    >
      <div>
        <b-col md="6">
          <b-form-group
            label="Tipo do reajuste:"
            label-for="tipo_reajuste"
          >
            <b-form-select
              id="tipo_reajuste"
              v-model="tipo_reajuste"
              :options="opcoesTipoReajuste"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Informe o percentual do reajuste %"
            label-for="percentual"
          >
            <money
              class="form-control"
              v-model="percentual"
              v-bind="configMoney"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Aplicar reajuste sobre:"
            label-for="aplicar_reajuste_sobre"
          >
            <div class="border rounded p-1">
              <b-button-group
                id="aplicar_reajuste_sobre"
                size="sm"
                class="w-100"
              >
                <b-button
                  class="font-weight-bold flex-fill"
                  :variant="
                    aplicar_reajuste_sobre === 'preco'
                      ? 'primary'
                      : 'outline-primary'
                  "
                  @click="aplicar_reajuste_sobre = 'preco'"
                >
                  Preço de venda
                </b-button>
                <b-button
                  class="font-weight-bold flex-fill d-inline-flex align-items-center justify-content-center"
                  :variant="
                    aplicar_reajuste_sobre === 'custo'
                      ? 'primary'
                      : 'outline-primary'
                  "
                  @click="aplicar_reajuste_sobre = 'custo'"
                >
                  <span class="d-inline-flex align-items-center">
                    Custo
                    <b-icon
                      icon="info-circle"
                      class="ml-1"
                      v-b-tooltip.hover.top="
                        'Atenção: no reajuste sobre o custo, o valor aplicado considera o custo mais o percentual informado. Ex: custo de R$ 100 com 100% de acréscimo adiciona R$ 200 ao preço de venda.'
                      "
                    />
                  </span>
                </b-button>
              </b-button-group>
            </div>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="pesado"
            label-for="pesado"
            label="Estoque Total"
            v-b-tooltip.hover.top="
              'Marcar para aplicar o reajuste para todo o estoque, caso marcar essa opção vai atualizar todo seu estoque'
            "
          >
            <span class="switch switch-icon">
              <label>
                <input
                  type="checkbox"
                  :value="false"
                  @change="setEstoqueTotal"
                  :checked="estoque_total == true"
                />
                <span></span>
              </label>
            </span>
          </b-form-group>
        </b-col>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="ajustaPreco"
            ref="reajustePreco"
            class="mr-5"
          >
            Ajustar preço(s)
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="duplicarProduto"
      title="Deseja duplicar o produto selecionado?"
      centered
      size="xs"
      @hidden="limparDuplicacaoProduto"
    >
      <label
        >Produto a ser duplicado:
        <p>{{ produtoParaDuplicar?.descricao }}</p>
      </label>
      <b-form-group label="Nova descrição" label-for="newDescriptionProduct">
        <b-form-input v-model="newProductDescription" />
      </b-form-group>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="duplicarProduto"
            ref="doubleProduct"
            class="mr-5"
          >
            Confirmar
          </b-button>
          <b-button
            @click="cancelarDuplicacaoProduto(cancel)"
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="replicarCampoMassa"
      title="Manutenção de produtos - Atualizar campo em massa"
      centered
      size="xl"
    >
      <!-- Modo de seleção -->
      <div class="row mb-4">
        <b-col md="12">
          <b-form-group label="Modo de atualização:">
            <b-form-radio-group v-model="modoReplicacao" :options="[
              { value: 'selecionados', text: 'Apenas produtos selecionados' },
              { value: 'todos', text: 'Todos os produtos (Estoque Total)' }
            ]" class="font-weight-bold"></b-form-radio-group>
          </b-form-group>
        </b-col>
      </div>

      <!-- Info do modo selecionado -->
      <div class="row" v-if="modoReplicacao === 'selecionados'">
        <b-col md="12">
          <b-alert show variant="info" class="mb-3">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <strong>📌 {{ produtosDestinoReplicacao.length + 1 }} produto(s) selecionado(s)</strong>
              </div>
            </div>
          </b-alert>
          <!-- Lista de produtos selecionados -->
          <div class="border rounded p-3 bg-light mb-3" style="max-height: 150px; overflow-y: auto;">
            <small class="font-weight-bold text-muted d-block mb-2">Produtos que receberão a atualização:</small>
            <div class="small">
              <div v-if="produtoOrigemReplicacao" :key="produtoOrigemReplicacao.id" class="ml-2 mb-1">
                <span class="badge badge-success">{{ produtoOrigemReplicacao.codigo }}</span>
                {{ produtoOrigemReplicacao.descricao }}
              </div>
              <div v-for="prod in produtosDestinoReplicacao" :key="prod.id" class="ml-2 mb-1">
                <span class="badge badge-success">{{ prod.codigo }}</span>
                {{ prod.descricao }}
              </div>
            </div>
          </div>
        </b-col>
      </div>
      <div class="row" v-if="modoReplicacao === 'todos'">
        <b-col md="12">
          <b-alert show variant="warning" class="mb-3">
            <div>
              <strong>⚠️ ATENÇÃO:</strong> Esta operação atualizará <strong>TODOS os produtos</strong> do seu estoque!
            </div>
          </b-alert>
        </b-col>
      </div>

      <hr class="my-4">

      <!-- Seleção do campo -->
      <div class="row">
        <b-col md="12">
          <b-form-group label="Selecione o campo a atualizar:" label-for="campoReplicar">
            <b-form-select
              id="campoReplicar"
              v-model="campoSelecionadoReplicacao"
              :options="camposDisponiveis"
              @change="resetarValorCampoReplicacao"
              placeholder="Escolha um campo..."
            ></b-form-select>
          </b-form-group>
        </b-col>
      </div>

      <!-- Campo de entrada simples (número/texto) -->
      <div class="row" v-if="campoSelecionadoReplicacao && !ehCampoComLooku()">
        <b-col md="12">
          <b-form-group label="Novo valor:" label-for="valorCampo">
            <b-form-input
              id="valorCampo"
              v-model="valorCampoReplicacao"
              :type="obterTipoCampo()"
              placeholder="Digite o novo valor"
              autofocus
            ></b-form-input>
          </b-form-group>
        </b-col>
      </div>

      <!-- Campo com busca (lookup) -->
      <div class="row" v-if="campoSelecionadoReplicacao && ehCampoComLooku()">
        <b-col md="12">
          <b-form-group label="Selecione o valor:" label-for="valorLookup">
            <VueSelect
              id="valorLookup"
              placeholder="Digite para buscar..."
              label="label"
              :filterable="false"
              @input="setSelecionadoItem"
              :options="resultadosLookup"
              @search="handleSearchDinamico"
              v-model="selecionadoItem"
              :clearable="true"
            >
              <template slot="no-options">
                <div class="text-center p-2">
                  <small class="text-muted">Digite para buscar...</small>
                </div>
              </template>
              <template slot="option" slot-scope="option">
                <div class="d-flex justify-content-between">
                  <strong>{{ option.label }}</strong>
                  <small class="text-muted ml-2">ID: {{ option.value }}</small>
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                  {{ option.label }}
                </div>
              </template>
            </VueSelect>
          </b-form-group>
          <div v-if="selecionadoItem && selecionadoItem.label" class="alert alert-success small mt-2 mb-0">
            ✅ Selecionado: <strong>{{ selecionadoItem.label }}</strong>
          </div>
        </b-col>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="executarReplicacaoCampo"
            ref="replicarCampoMassaBtn"
            :disabled="!campoSelecionadoReplicacao || !validarValorCampo()"
            class="mr-5"
          >
            Executar Atualização
          </b-button>
          <b-button @click="fecharModalReplicacao">
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <TableApp
      titulo="Cadastro de Produtos"
      acaoBtn="/#/produtos/novo"
      textoBtn="Novo"
      api-url="/produtos/filter"
      :fields="fieldsToShow"
      classFilterColumn="produto"
      ref="produto"
      :perPage="10"
      :multiselect="true"
    >
      <template slot="customRow" scope="props">
        <span slot="codigo" v-if="props.field == 'codigo'">
          <span class="pl-0 pt-8">
            <div class="d-flex align-items-center">
              <div>
                <a
                  class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                  >{{ props.rowData.codigo }}</a
                >
                <b-card-img
                  v-b-modal.view-product-imagem
                  :src="props.rowData.imagem"
                  class="rounded-0 ml-5"
                  style="width: 50px"
                  @click="
                    () => {
                      produtoToView = props.rowData.imagem;
                    }
                  "
                />
              </div>
            </div>
          </span>
        </span>
        <span slot="referencia" v-if="props.field == 'referencia'">
          <span class="pl-0 pt-8">
            <div class="d-flex align-items-center">
              <div>
                <a
                  class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                  >{{ props.rowData.referencia }}</a
                >
              </div>
            </div>
          </span>
        </span>
        <span slot="descricao" v-if="props.field == 'descricao'">
          <span class="pl-0 pt-8">
            <div class="d-flex align-items-center">
              <div>
                <a
                  class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                  >{{ props.rowData.descricao.substr(0, 50) }}</a
                >
                <span
                  class="text-muted font-weight-bold d-block"
                  v-if="props.rowData.desc_complementar"
                  >{{ props.rowData.desc_complementar }}</span
                >
              </div>
            </div>
          </span>
        </span>
        <span slot="fornecedor" v-if="props.field == 'fornecedor'">
          <span class="pl-0 pt-8">
            <div class="d-flex align-items-center">
              <div class="font-weight-bold">
                {{ props.rowData.fornecedor }}
              </div>
            </div>
          </span>
        </span>
        <span slot="marca" v-if="props.field == 'marca'">
          <span class="pl-0 pt-8">
            <div class="d-flex align-items-center">
              <div class="font-weight-bold">
                {{ props.rowData.marca }}
              </div>
            </div>
          </span>
        </span>
        <span slot="unidade_medida" v-if="props.field == 'unidade_medida'">
          <div class="font-weight-bold">
            {{ props.rowData.unidade_medida }}
          </div>
        </span>
        <span slot="custo" v-if="props.field == 'custo'">
          <div class="font-weight-bold">
            R$ {{ numberToReal(props.rowData.custo, "preco") }}
          </div>
        </span>
        <span slot="preco" v-if="props.field == 'preco'">
          <div class="font-weight-bold">
            R$ {{ numberToReal(props.rowData.preco, "preco") }}
          </div>
        </span>
        <span slot="quantidade" v-if="props.field == 'quantidade'">
          <div class="font-weight-bold">
            {{ numberToReal(props.rowData.quantidade, "quantidade") }}
          </div>
        </span>
        <span slot="preco_atacado" v-if="props.field == 'preco_atacado'">
          <div class="font-weight-bold">
            {{ numberToReal(props.rowData.preco_atacado, "preco_atacado") }}
          </div>
        </span>
        <span
          slot="quantidade_atacado"
          v-if="props.field == 'quantidade_atacado'"
        >
          <div class="font-weight-bold">
            {{
              numberToReal(
                props.rowData.quantidade_atacado,
                "quantidade_atacado"
              )
            }}
          </div>
        </span>
        <span slot="estoque_minimo" v-if="props.field == 'estoque_minimo'">
          <div class="font-weight-bold">
            {{ numberToReal(props.rowData.estoque_minimo, "estoque_minimo") }}
          </div>
        </span>
        <span
          slot="quantidade_reservada_condicional"
          v-if="props.field == 'quantidade_reservada_condicional'"
        >
          <div class="font-weight-bold">
            {{
              numberToReal(
                props.rowData.quantidade_reservada_condicional,
                "quantidade"
              )
            }}
          </div>
        </span>
        <span slot="cod_barras" v-if="props.field == 'cod_barras'">
          <div class="font-weight-bold">
            {{ props.rowData.cod_barras }}
          </div>
        </span>
        <span slot="ncm" v-if="props.field == 'ncm'">
          <div class="font-weight-bold">
            {{ props.rowData.ncm }}
          </div>
        </span>
        <span slot="tributacao" v-if="props.field == 'tributacao'">
          <div class="font-weight-bold">
            {{ props.rowData.tributacao }}
          </div>
        </span>
        <span slot="tipo_produto" v-if="props.field == 'tipo_produto'">
          <div class="font-weight-bold">
            {{ props.field.tipo_produto }}
          </div>
        </span>
        <span
          class="pl-0 pt-8"
          slot="data_ultima_compra"
          v-if="props.field == 'data_ultima_compra'"
        >
          <div class="d-flex align-items-center">
            <div class="font-weight-bold">
              {{ formatDate(props.rowData.data_ultima_compra) }}
            </div>
          </div>
        </span>
        <span
          class="pl-0 pt-8"
          slot="data_ultima_venda"
          v-if="props.field == 'data_ultima_venda'"
        >
          <div class="d-flex align-items-center">
            <div class="font-weight-bold">
              {{ formatDate(props.rowData.data_ultima_venda) }}
            </div>
          </div>
        </span>
        <span slot="status" v-if="props.field == 'status'">
          <span
            v-if="props.rowData.ativo == true"
            class="label label-lg label-inline label-light-success"
            >Ativo</span
          >
          <span v-else class="label label-lg label-inline label-light-danger"
            >Inativo</span
          >
        </span>
        <span slot="actions" v-if="props.field == 'actions'">
          <div class="row-actions" style="text-align: right !important">
            <span style="overflow: visible; position: relative; min-width: 190px">
              <div class="dropdown dropdown-inline d-flex justify-content-end">
                <b-button-group
                  size="sm"
                  class="produto-acoes-dropdown mr-2"
                >
                  <b-button
                    variant="info"
                    @click="editarProdutoDaLista(props.rowData)"
                  >
                    Editar
                  </b-button>
                  <b-button
                    :id="`produto-acoes-${props.rowData.id}`"
                    variant="info"
                    class="dropdown-toggle dropdown-toggle-split"
                    aria-label="Abrir ações do produto"
                  >
                    <span class="sr-only">Abrir ações do produto</span>
                  </b-button>
                </b-button-group>
                <b-popover
                  :target="`produto-acoes-${props.rowData.id}`"
                  triggers="click blur"
                  placement="bottom-end"
                  boundary="viewport"
                  container="body"
                  custom-class="produto-acoes-popover"
                >
                  <div class="produto-acoes-menu">
                    <button
                      type="button"
                      class="dropdown-item"
                      @click="abrirMovimentacoesProduto(props.rowData)"
                    >
                      <b-icon icon="graph-up" class="mr-2" /> Movimentações
                    </button>
                    <button
                      type="button"
                      class="dropdown-item"
                      @click="abrirDuplicacaoProduto(props.rowData)"
                    >
                      <b-icon icon="files" class="mr-2" /> Duplicar produto
                    </button>
                    <button
                      type="button"
                      class="dropdown-item"
                      @click="abrirModalAjusteEstoque([props.rowData])"
                    >
                      <b-icon icon="box-seam" class="mr-2" /> Ajustar estoque
                    </button>
                    <div class="dropdown-divider" />
                    <button
                      type="button"
                      class="dropdown-item"
                      @click="confirmarAlteracaoStatusProduto(props.rowData)"
                    >
                      <b-icon
                        :icon="
                          props.rowData.ativo ? 'pause-circle' : 'play-circle'
                        "
                        class="mr-2"
                      />
                      {{
                        props.rowData.ativo
                          ? "Inativar produto"
                          : "Ativar produto"
                      }}
                    </button>
                  </div>
                </b-popover>
                <button
                  @click="excluir(props.rowData)"
                  class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2"
                >
                  <TrashCanIcon :size="16" />
                </button>
              </div>
            </span>
          </div>
        </span>
      </template>
    </TableApp>

    <b-modal
      id="ajusteManualEstoque"
      title="Ajuste manual de estoque"
      centered
      size="xl"
      modal-class="ajuste-estoque-modal"
      @hidden="limparAjusteEstoque"
    >
      <div class="ajuste-estoque-panel mb-5">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <div>
            <div class="font-weight-bolder text-dark font-size-h5 mb-1">
              Movimentação manual
            </div>
            <div class="text-muted font-size-sm">
              A operação selecionada será aplicada somente aos itens marcados.
            </div>
          </div>
          <span class="ajuste-estoque-count">
            {{ itensAjusteEstoqueMarcados.length }} marcado(s)
          </span>
        </div>
        <div class="row">
          <b-col md="4">
            <b-form-group label="Operação" label-for="operacaoAjusteEstoque">
              <b-form-radio-group
                id="operacaoAjusteEstoque"
                v-model="ajusteEstoqueOperacao"
                :options="opcoesAjusteEstoque"
                buttons
                button-variant="outline-primary"
                class="ajuste-estoque-operacoes"
                size="sm"
              />
            </b-form-group>
            <div class="ajuste-estoque-rapido mt-3">
              <b-form-checkbox
                v-model="ajusteEstoqueRapido"
                switch
                @change="limparStatusItensMarcadosAjusteEstoque"
              >
                Ajuste rápido
              </b-form-checkbox>
              <b-form-input
                v-if="ajusteEstoqueRapido"
                v-model.number="ajusteEstoqueRapidoQuantidade"
                type="number"
                min="0"
                step="0.0001"
                size="sm"
                class="mt-2"
                placeholder="Quantidade para itens marcados"
                @input="limparStatusItensMarcadosAjusteEstoque"
              />
            </div>
          </b-col>
          <b-col md="8">
            <b-form-group
              label="Adicionar produto"
              label-for="produtoAjusteEstoque"
            >
              <VueSelect
                id="produtoAjusteEstoque"
                placeholder="Digite código, referência, barras ou descrição"
                label="label"
                :filterable="false"
                :options="produtosAjusteEstoque"
                @search="buscarProdutosAjusteEstoque"
                @input="adicionarProdutoAjusteEstoque"
                v-model="produtoSelecionadoAjusteEstoque"
                :clearable="true"
              >
                <template slot="no-options">
                  <div class="text-center p-2">
                    <small class="text-muted">Digite ao menos 2 caracteres</small>
                  </div>
                </template>
                <template slot="option" slot-scope="option">
                  <div>
                    <strong>{{ option.codigo }} - {{ option.descricao }}</strong>
                    <small class="text-muted d-block">
                      Estoque: {{ numberToReal(option.quantidade, "quantidade") }}
                    </small>
                  </div>
                </template>
              </VueSelect>
            </b-form-group>
          </b-col>
        </div>
      </div>

      <div class="table-responsive ajuste-estoque-table">
        <table class="table table-head-custom table-vertical-center mb-0">
          <thead>
            <tr>
              <th style="width: 42px"></th>
              <th>Produto</th>
              <th style="width: 130px">Atual</th>
              <th style="width: 220px">Lote/variação</th>
              <th style="width: 150px">Quantidade</th>
              <th style="width: 130px">Resultado</th>
              <th style="width: 60px"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!itensAjusteEstoque.length">
              <td colspan="7" class="text-center text-muted py-8">
                Nenhum produto adicionado
              </td>
            </tr>
            <tr
              v-for="(item, index) in itensAjusteEstoque"
              :key="item.uid"
              :class="{ 'ajuste-estoque-row-success': item.ajusteStatus === 'success' }"
            >
              <td>
                <b-form-checkbox
                  v-model="item.marcado"
                  @change="limparStatusItemAjusteEstoque(item, $event)"
                />
              </td>
              <td>
                <div class="font-weight-bold">
                  {{ item.codigo }} - {{ item.descricao }}
                </div>
                <small class="text-muted ajuste-estoque-tags">
                  {{ item.unidade_medida || "UN" }}
                  <span
                    v-if="item.lote"
                    class="label label-inline label-light-info"
                    >Lote</span
                  >
                  <span
                    v-if="item.variavel"
                    class="label label-inline label-light-warning"
                    >Variação</span
                  >
                  <span
                    v-if="item.ajusteStatus === 'success'"
                    class="label label-inline label-light-success"
                    >Aplicado</span
                  >
                </small>
                <small
                  v-if="item.ajusteMensagem"
                  class="text-success d-block mt-1"
                >
                  {{ item.ajusteMensagem }}
                </small>
              </td>
              <td>
                <div class="font-weight-bold text-dark">
                  {{ numberToReal(getQuantidadeBaseAjusteEstoque(item), "quantidade") }}
                </div>
                <small
                  v-if="item.lote || item.variavel"
                  class="text-muted"
                >
                  Geral: {{ numberToReal(item.quantidadeAtual, "quantidade") }}
                </small>
              </td>
              <td>
                <b-form-select
                  v-if="item.lote"
                  v-model="item.id_produto_lote"
                  :options="item.lotes"
                  size="sm"
                  @change="limparStatusItemAjusteEstoque(item, true)"
                />
                <b-form-select
                  v-else-if="item.variavel"
                  v-model="item.combinacaoIndex"
                  :options="item.combinacoes"
                  size="sm"
                  @change="limparStatusItemAjusteEstoque(item, true)"
                />
                <span v-else class="text-muted">Produto simples</span>
              </td>
              <td>
                <b-form-input
                  v-model.number="item.quantidade"
                  type="number"
                  min="0"
                  step="0.0001"
                  size="sm"
                  :disabled="ajusteEstoqueRapido"
                  :placeholder="
                    ajusteEstoqueRapido ? 'Ajuste rápido ativo' : ''
                  "
                  @input="limparStatusItemAjusteEstoque(item, true)"
                />
              </td>
              <td>
                <span
                  class="ajuste-estoque-resultado"
                  :class="classeResultadoAjusteEstoque(item)"
                >
                  {{ numberToReal(resultadoAjusteEstoque(item), "quantidade") }}
                </span>
              </td>
              <td>
                <button
                  type="button"
                  class="btn btn-sm btn-light-danger btn-icon"
                  @click="removerItemAjusteEstoque(index)"
                >
                  <TrashCanIcon :size="16" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <template #modal-footer="{ cancel }">
        <div>
          <b-button
            variant="primary"
            ref="ajusteManualEstoqueBtn"
            class="mr-3"
            :disabled="!podeSalvarAjusteEstoque"
            @click="salvarAjusteEstoque"
          >
            Aplicar {{ operacaoAjusteEstoqueTexto.toLowerCase() }}
          </b-button>
          <b-button variant="light" @click="cancel()">Cancelar</b-button>
        </div>
      </template>
    </b-modal>

    <b-modal id="view-product-imagem" centered title="Imagem do produto">
      <b-card-img :src="produtoToView" class="rounded-0"></b-card-img>
      <template #modal-footer="{ ok }">
        <div>
          <b-button @click="ok" variant="primary"> Ok </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import ToggleSwitchOutline from "vue-material-design-icons/ToggleSwitchOutline.vue";
import DragVertical from "vue-material-design-icons/DragVertical.vue";
import draggable from "vuedraggable";
import BarcodeScan from "vue-material-design-icons/BarcodeScan.vue";
import MoneySymbol from "vue-material-design-icons/CurrencyUsd.vue";
import Balence from "vue-material-design-icons/BatteryCharging.vue";
import PackageVariantClosed from "vue-material-design-icons/PackageVariantClosed.vue";
import TableApp from "@/components/Table/Table2";
import { SistemaMixin } from "@/modules/Application";
import { onboardStore } from "../../../onboardStore";
import FilterFields from "@/components/FilterFields";
import Menu from "vue-material-design-icons/Menu";
import { actionsStore } from "@/components/Table/actionsStore";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import swal from "sweetalert";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import _ from "lodash";

export default {
  name: "app-produto",
  mixins: [SistemaMixin],
  components: {
    TrashCanIcon,
    TableApp,
    FilterFields,
    Menu,
    Money,
    ToggleSwitchOutline,
    DragVertical,
    draggable,
    BarcodeScan,
    Balence,
    MoneySymbol,
    PackageVariantClosed,
    VueSelect,
  },
  data() {
    return {
      actionsStore,
      onboardStore,
      newProductDescription: null,
      produtoDuplicarAcao: null,
      id_configuracao_lista: null,
      selectedFields: [],
      fieldsToShow: [],
      localFields: [],
      extraFields: [
        {
          index: 9,
          label: "Preço atacado",
          field: "preco_atacado",
          width: "8%",
          sortable: true,
          slot: true,
        },
        {
          index: 10,
          label: "Qtd. atacado",
          field: "quantidade_atacado",
          width: "8%",
          sortable: true,
          slot: true,
        },
        {
          index: 11,
          label: "Cód. de Barra",
          field: "cod_barras",
          width: "8%",
          sortable: false,
          slot: false,
        },
        {
          index: 12,
          label: "Marca",
          field: "marca",
          width: "8%",
          sortable: true,
          slot: true,
        },
        {
          index: 13,
          label: "NCM",
          field: "ncm",
          width: "8%",
          sortable: false,
          slot: true,
        },
        {
          index: 14,
          label: "Dt Última Compra",
          field: "data_ultima_compra",
          width: "8%",
          sortable: true,
          slot: true,
        },
        {
          index: 15,
          label: "Dt Última Venda",
          field: "data_ultima_venda",
          width: "8%",
          sortable: true,
          slot: true,
        },
        {
          index: 16,
          label: "Estoque mínimo",
          field: "estoque_minimo",
          width: "8%",
          sortable: true,
          slot: true,
        },
        {
          index: 17,
          label: "Tributação",
          field: "tributacao",
          width: "8%",
          sortable: false,
          slot: false,
        },
        {
          index: 18,
          label: "Tipo Mercadoria",
          field: "tipo_produto",
          width: "8%",
          sortable: false,
          slot: false,
        },       
        {
          index: 19,
          label: "Grupo",
          field: "grupo",
          width: "8%",
          sortable: false,
          slot: false,
        },
        {
          index: 20,
          label: "CFOP NFe",
          field: "cfop",
          width: "8%",
          sortable: false,
          slot: false,
        },
        {
          index: 21,
          label: "CFOP NFce",
          field: "cfopNfce",
          width: "8%",
          sortable: false,
          slot: false,
        },
        {
          index: 22,
          label: "CST/CSOSN não contribuinte",
          field: "cstCsosn",
          width: "8%",
          sortable: false,
          slot: false,
        },
        {
          index: 23,
          label: "CST/CSOSN contribuinte",
          field: "cstCsosnContribuinte",
          width: "8%",
          sortable: false,
          slot: false,
        },
        {
          index: 24,
          label: "Qtd. reservada condicional",
          field: "quantidade_reservada_condicional",
          width: "8%",
          sortable: true,
          slot: true,
        },
      ],
      produtoToView: null,
      fields: [
        {
          index: 0,
          label: "Código",
          field: "codigo",
          type: "text",
          slot: true,
          sortable: true,
          width: "5%",
          required: true,
          filterOptions: {
            enabled: false,
            placeholder: "Pesquisar codigo",
          },
        },
        {
          index: 1,
          label: "Referência",
          field: "referencia",
          type: "text",
          slot: true,
          sortable: true,
          width: "5%",
          filterOptions: {
            enabled: false,
            placeholder: "Pesquisar referência",
          },
        },
        {
          index: 2,
          label: "Descrição",
          field: "descricao",
          type: "text",
          slot: true,
          sortable: true,
          width: "30%",
          required: true,
          filterOptions: {
            enabled: false,
            placeholder: "Pesquisar descrição",
          },
        },
        {
          index: 3,
          label: "Fornecedor",
          field: "fornecedor",
          type: "text",
          slot: true,
          sortable: false,
          width: "15%",
          filterOptions: {
            enabled: false,
            placeholder: "Pesquisar nome",
          },
        },
        {
          index: 4,
          label: "UN",
          field: "unidade_medida",
          width: "5%",
          sortable: false,
          slot: true,
          filterOptions: {
            enabled: false,
          },
        },
        {
          index: 5,
          label: "Custo",
          field: "custo",
          width: "8%",
          sortable: true,
          slot: true,
          filterOptions: {
            enabled: false,
          },
        },
        {
          index: 6,
          label: "Preço",
          field: "preco",
          width: "8%",
          sortable: true,
          slot: true,
        },
        {
          index: 7,
          label: "Quantidade",
          field: "quantidade",
          width: "8%",
          sortable: true,
          slot: true,
        },
        {
          index: 98,
          label: "Status",
          field: "status",
          width: "2%",
          sortable: false,
          slot: true,
          filterOptions: {
            enabled: false,
          },
        },
        {
          index: 99,
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
          width: "15%",
          required: true,
          filterOptions: {
            enabled: false,
          },
        },
      ],
      percentual: 0,
      tipo_reajuste: "acrescimo",
      opcoesTipoReajuste: [
        { value: "acrescimo", text: "Acréscimo" },
        { value: "desconto", text: "Desconto" },
      ],
      aplicar_reajuste_sobre: "preco",
      configMoney: settingMoney,
      estoque_total: false,
      modeloBalanca: null,
      balancas: [
        {
          id: 1,
          descricao: "Padrão MGV (Toledo, Prix)",
        },
      ],
      ajusteEstoqueOperacao: "entrada",
      ajusteEstoqueRapido: false,
      ajusteEstoqueRapidoQuantidade: null,
      produtoSelecionadoAjusteEstoque: null,
      produtosAjusteEstoque: [],
      itensAjusteEstoque: [],
      opcoesAjusteEstoque: [
        { value: "entrada", text: "Entrada" },
        { value: "saida", text: "Saída" },
        { value: "ajuste", text: "Sobrescrever" },
      ],
      // Para replicação de campo em massa
      camposDisponiveis: [
        { value: "id_grupo", text: "Grupo do Produto", comLookup: true, tipo: "lookup" },
        { value: "id_pessoa", text: "Fornecedor", comLookup: true, tipo: "lookup" },
        { value: "id_perfil_tributario", text: "Perfil Tributário", comLookup: true, tipo: "lookup" },
        { value: "id_tributacao", text: "Tributação", comLookup: true, tipo: "lookup" },
        { value: "id_tributacao_st", text: "Tributação ST", comLookup: true, tipo: "lookup" },
        { value: "id_medida", text: "Unidade de Medida", comLookup: true, tipo: "lookup" },
        { value: "id_ncm", text: "NCM", comLookup: true, tipo: "lookup" },
        { value: "id_cfop", text: "CFOP NFe", comLookup: true, tipo: "lookup" },
        { value: "id_cfop_nfce", text: "CFOP NFce", comLookup: true, tipo: "lookup" },
        { value: "id_origem", text: "Origem da Mercadoria", comLookup: true, tipo: "lookup" },
        { value: "id_cst_csosn", text: "CST Não Contribuinte", comLookup: true, tipo: "lookup" },
        { value: "id_cst_csosn_contribuinte", text: "CST Contribuinte", comLookup: true, tipo: "lookup" },
        { value: "id_cest", text: "Código CEST", comLookup: true, tipo: "lookup" },
        { value: "custo", text: "Custo Unitário", comLookup: false, tipo: "number" },
        { value: "preco", text: "Preço de Venda", comLookup: false, tipo: "number" },
        { value: "preco_atacado", text: "Preço Atacado", comLookup: false, tipo: "number" },
        { value: "quantidade_atacado", text: "Quantidade Atacado", comLookup: false, tipo: "number" },
        { value: "estoque_minimo", text: "Estoque Mínimo", comLookup: false, tipo: "number" },
        { value: "ipi", text: "% IPI", comLookup: false, tipo: "number" },
        { value: "pis", text: "% PIS", comLookup: false, tipo: "number" },
        { value: "cofins", text: "% COFINS", comLookup: false, tipo: "number" },
        { value: "mva", text: "% MVA", comLookup: false, tipo: "number" },
      ],
      modoReplicacao: "selecionados", // "selecionados" ou "todos"
      campoSelecionadoReplicacao: null,
      valorCampoReplicacao: null, // Para inputs normais
      produtoOrigemReplicacao: null,
      produtosDestinoReplicacao: [],
      // Para campos com lookup
      resultadosLookup: [],
      selecionadoItem: null,
      // Origens da mercadoria (lista estática)
      origens: [
        {
          id: 0,
          descricao: "0 - Nacional, exceto as indicadas nos códigos 3 a 5",
        },
        {
          id: 1,
          descricao:
            "1 - Estrangeira - Importação direta, exceto a indicada no código 6",
        },
        {
          id: 2,
          descricao:
            "2 - Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7",
        },
        {
          id: 3,
          descricao:
            "3 - Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40%",
        },
        {
          id: 4,
          descricao:
            "4 - Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos de que tratam o Decreto-Lei nº 288/1967.",
        },
        {
          id: 5,
          descricao:
            "5 - Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40%",
        },
        {
          id: 6,
          descricao:
            "6 - Estrangeira - Importação direta, sem similar nacional, constante em lista de Resolução Camex e gás natural",
        },
        {
          id: 7,
          descricao:
            "7 - Estrangeira - Adquirida no mercado interno, sem similar nacional, constante em lista de Resolução Camex e gás natural",
        },
        {
          id: 8,
          descricao:
            "8 – Nacional: mercadoria ou bem com Conteúdo de Importação superior a 70%;",
        },
      ],
    };
  },
  async created() {
    this.fieldsToShow = _.cloneDeep(this.fields);
    this.selectedFields = _.cloneDeep(this.fields);
    try {
      const { data } = await this.$http.post("/configuracao-lista/find", {
        modulo: 1,
      });
      this.id_configuracao_lista = data?.id_configuracao_lista ?? null;
      if (data.lista.length > 0) {
        this.fieldsToShow = this.normalizeSavedFields(data.lista);
        this.selectedFields = _.cloneDeep(this.fieldsToShow);
      }
    } catch (error) {

      console.log(error);
    }
    this.syncLocalFields();
  },
  methods: {
    isFieldRequired(field) {
      return field.required === true;
    },
    isFieldShow(field) {
      return !!this.fieldsToShow.find((el) => el.field === field);
    },
    normalizeSavedFields(savedFields) {
      // Respeita a ordem gravada, mesclando com as definições locais (source of truth).
      const localByField = this.allFields.reduce((acc, field) => {
        acc[field.field] = field;
        return acc;
      }, {});
      const ordered = savedFields
        .map((saved) => {
          const local = localByField[saved.field];
          return local ? _.cloneDeep(local) : _.cloneDeep(saved);
        })
        .filter(Boolean);

      // Garante colunas obrigatórias ausentes.
      this.allFields.forEach((field) => {
        const isPresent = ordered.find((f) => f.field === field.field);
        if (!isPresent && this.isFieldRequired(field)) {
          ordered.push(_.cloneDeep(field));
        }
      });

      return ordered;
    },
    syncLocalFields() {
      const visibleKeys = new Set(
        this.fieldsToShow.map((field) => field.field)
      );
      const localByField = this.allFields.reduce((acc, field) => {
        acc[field.field] = field;
        return acc;
      }, {});
      // Visíveis primeiro (na ordem salva), depois as ocultas (ordem original de allFields).
      const orderedVisible = this.fieldsToShow.filter(
        (field) => !!localByField[field.field]
      );
      const hiddenFields = this.allFields.filter(
        (field) => !visibleKeys.has(field.field)
      );
      this.localFields = [...orderedVisible, ...hiddenFields];
    },
    handleSelectFieldToShow(value, field) {
      const localField = this.allFields.find((el) => el.field === field);
      if (value) {
        const exists = this.selectedFields.find((el) => el.field === field);
        if (!exists && localField) {
          this.selectedFields = [...this.selectedFields, _.cloneDeep(localField)];
        }
      } else if (!this.isFieldRequired(localField || {})) {
        this.selectedFields = this.selectedFields.filter(
          (el) => el.field !== field
        );
      }
      this.fieldsToShow = _.cloneDeep(this.selectedFields);
    },
    async gerarArquivoTxt() {
      this.addLoadingToButton("gerarTXT");
      try {
        const { data } = await this.$http.post(
          "/produtos/gerar-arquiv-balanca",
          {
            modelo: this.modeloBalanca,
          }
        );

        if (data) {
          window.open(data["url_file"], "_blank");
        }
        this.$toast.success("Arquivo gerado com sucesso!");
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("gerarTXT");
      this.$root.$emit("bv::toggle::collapse", "sidebar-arquivo-balanca");
    },
    async handleSaveFields() {
      this.addLoadingToButton("salvarFields");
      // Aplica a ordem definida no painel (localFields) e considera apenas as ativas.
      const selectedKeys = new Set(
        this.selectedFields.map((field) => field.field)
      );
      const fieldsToSave = this.localFields.filter((field) =>
        selectedKeys.has(field.field)
      );
      try {
        const { data } = await this.$http.post(
          this.id_configuracao_lista
            ? "/configuracao-lista/update"
            : "/configuracao-lista/create",
          {
            ...(this.id_configuracao_lista && {
              id_configuracao_lista: this.id_configuracao_lista,
            }),
            modulo: 1,
            lista: fieldsToSave,
          }
        );
        this.$toast.success(data.msg);
        this.selectedFields = _.cloneDeep(fieldsToSave);
        this.fieldsToShow = _.cloneDeep(fieldsToSave);
        if (!this.id_configuracao_lista)
          this.id_configuracao_lista = data.data.id_configuracao_lista;
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("salvarFields");
      this.$root.$emit("bv::toggle::collapse", "sidebar-produto-fields");
    },
    async duplicarProduto() {
      const id_produto = this.produtoParaDuplicar?.id;
      this.addLoadingToButton("doubleProduct");
      if (!id_produto) {
        this.$toast.error("Produto sem id válido!");
        this.removeLoadingToButton("doubleProduct");
        return;
      }
      if (!this.newProductDescription) {
        this.$toast.error("Nova descrição obrigatória!");
        this.removeLoadingToButton("doubleProduct");
        return;
      }
      try {
        await this.$http.post("/produtos/duplicar", {
          id_produto,
          descricao: this.newProductDescription,
        });
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Produto duplicado com sucesso!");
        this.$refs.produto.refresh();
        this.newProductDescription = null;
        this.produtoDuplicarAcao = null;
        this.$bvModal.hide("duplicarProduto");
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("doubleProduct");
    },
    abrirDuplicacaoProduto(produto) {
      this.produtoDuplicarAcao = produto;
      this.newProductDescription = null;
      this.$bvModal.show("duplicarProduto");
    },
    cancelarDuplicacaoProduto(cancel) {
      if (!this.produtoDuplicarAcao) {
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.actionsStore.selectedRows = [];
      }
      cancel();
    },
    limparDuplicacaoProduto() {
      this.produtoDuplicarAcao = null;
      this.newProductDescription = null;
    },
    editarProdutoDaLista(produto) {
      this.$router.push({
        name: "produtosUpdate",
        params: { id_produto: produto.id },
      });
    },
    abrirMovimentacoesProduto(produto) {
      this.$router.push({
        name: "produtoMovimentacoes",
        params: { id_produto: produto.id },
      });
    },
    confirmarAlteracaoStatusProduto(produto) {
      this.getRequestAdmin(() => {
        const acao = produto.ativo ? "inativar" : "ativar";
        this.$swal
          .fire({
            icon: "warning",
            title: `Deseja ${acao} o produto ${produto.descricao}?`,
            showCancelButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
          })
          .then(async (resultado) => {
            if (!resultado.isConfirmed) return;
            try {
              const { data } = await this.$http.post("/produtos/alterar-status", {
                id_produto: produto.id,
                ativo: !produto.ativo,
              });
              this.$toast.success(data.message);
              this.$refs.produto.refresh();
            } catch (error) {
              this.$toast.error(
                error?.response?.data?.message ||
                  "Não foi possível alterar o status do produto."
              );
            }
          });
      });
    },
    async excluirProduto() {
      this.addLoadingToButton("excluirProdutos");
      try {
        await this.$http
          .post("/produtos/delete-all", {
            produtos: this.actionsStore.selectedRows.map((produto) => ({
              id: produto.id,
            })),
          })
          .then((result) => {
            this.actionsStore.selectedRows = [];
            this.actionsStore.updateTable = !this.actionsStore.updateTable;
            this.$toast.success("Solicitação realizada com sucesso!");
            this.$refs.produto.refresh();
            this.$bvModal.hide("menuAcoes");
            this.$bvModal.hide("excluirProdutos");
            swal.stopLoading();
            swal.close();
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
        this.actionsStore.selectedRows = [];
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$bvModal.hide("menuAcoes");
        this.$bvModal.hide("excluirProdutos");
      } catch (error) {
        this.$bvModal.hide("excluirProdutos");
      }
      this.removeLoadingToButton("excluirProdutos");
    },
    excluir(data) {
      this.getRequestAdmin(() => {
        this.$swal
          .fire({
            icon: "warning",
            title: "Excluir o Produto " + data.descricao + "?",
            showCancelButton: true,
            confirmButtonText: `Sim`,
            cancelButtonText: `Não`,
            confirmButtonColor: "#f64e60",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              await this.$http.post("/produtos/delete", {
                id: data.id,
              });
              this.$refs.produto.refresh();
              this.$toast.success("Produto excluído!");
            }
          });
      });
    },
    setEstoqueTotal() {
      this.estoque_total = this.estoque_total == true ? false : true;
    },
    async gerarCodigoBarraPesado() {
      this.addLoadingToButton("gerarCodigoBarra");
      try {
        await this.$http.post("/produtos/gerar-barra-pesados");
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Código de barras gerado com sucesso!");
        this.$refs.produto.refresh();
        this.actionsStore.selectedRows = [];
        this.$bvModal.hide("produtosPesados");
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("gerarCodigoBarra");
    },
    async ajustaPreco() {
      this.addLoadingToButton("reajustePreco");
      if (!this.percentual) {
        this.$toast.error("Informe o percentual!");
        this.removeLoadingToButton("reajustePreco");
        return;
      }
      try {
        await this.$http.post("/produtos/ajuste-preco", {
          produtos: this.actionsStore.selectedRows.map((produto) => ({
            id_produto: produto.id,
          })),
          estoque_total: this.estoque_total,
          percentual: this.percentual,
          tipo_reajuste: this.tipo_reajuste,
          aplicar_reajuste_sobre: this.aplicar_reajuste_sobre,
        });
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Ajuste aplicado com sucesso!");
        this.$refs.produto.refresh();
        this.percentual = 0;
        this.tipo_reajuste = "acrescimo";
        this.aplicar_reajuste_sobre = "preco";
        this.estoque_total = false;
        this.actionsStore.selectedRows = [];
        this.$bvModal.hide("reajustePreco");
      } catch (error) {
        this.percentual = 0;
        this.tipo_reajuste = "acrescimo";
        this.aplicar_reajuste_sobre = "preco";
        this.estoque_total = false;
        console.log(error);
      }
      this.removeLoadingToButton("reajustePreco");
    },
    abrirModalAjusteEstoque(produtosPreSelecionados = null) {
      this.getRequestAdmin(() => {
        this.itensAjusteEstoque = [];
        this.ajusteEstoqueOperacao = "entrada";
        this.ajusteEstoqueRapido = false;
        this.ajusteEstoqueRapidoQuantidade = null;
        const produtos = Array.isArray(produtosPreSelecionados)
          ? produtosPreSelecionados
          : this.actionsStore.selectedRows;
        if (produtos.length) {
          produtos.forEach((produto) => {
            this.adicionarProdutoAjusteEstoque(produto);
          });
        }
        this.$bvModal.show("ajusteManualEstoque");
      });
    },
    abrirTerminalConsulta() {
      const route = this.$router.resolve({ name: "terminalConsulta" });
      window.open(route.href, "_blank");
    },
    buscarProdutosAjusteEstoque(search, loading) {
      if (!search || search.length < 2) {
        this.produtosAjusteEstoque = [];
        if (loading) loading(false);
        return;
      }

      if (loading) loading(true);
      this.executarBuscaProdutosAjusteEstoque(search, loading);
    },
    executarBuscaProdutosAjusteEstoque: _.debounce(async function(search, loading) {
      try {
        const { data } = await this.$http.post("/produtos/busca-ajuste-estoque", {
          filter: search,
        });

        this.produtosAjusteEstoque = (data?.data || data || []).map((produto) => ({
          ...produto,
          label: `${produto.codigo} - ${produto.descricao}`,
        }));
      } catch (error) {
        console.log(error);
        this.produtosAjusteEstoque = [];
      }

      if (loading) loading(false);
    }, 350),
    async adicionarProdutoAjusteEstoque(produto) {
      if (!produto) return;

      const produtoJaAdicionado = this.itensAjusteEstoque.some(
        (item) => String(item.id_produto) === String(produto.id)
      );

      if (produtoJaAdicionado) {
        this.produtoSelecionadoAjusteEstoque = null;
        this.$toast.error("Este produto já foi adicionado ao ajuste.");
        return;
      }

      const item = {
        uid: `${produto.id}-${Date.now()}-${Math.random()}`,
        id_produto: produto.id,
        codigo: produto.codigo,
        descricao: produto.descricao,
        unidade_medida: produto.unidade_medida,
        quantidadeAtual: Number(produto.quantidade || 0),
        quantidade: null,
        marcado: true,
        lote: !!produto.lote,
        variavel: !!produto.variavel,
        id_produto_lote: null,
        lotes: [{ value: null, text: "Selecione" }],
        combinacaoIndex: null,
        combinacao: null,
        combinacoes: [{ value: null, text: "Selecione" }],
        combinacoesRaw: [],
        ajusteStatus: null,
        ajusteMensagem: null,
      };

      this.itensAjusteEstoque.push(item);
      this.produtoSelecionadoAjusteEstoque = null;

      if (item.lote) {
        await this.carregarLotesAjusteEstoque(item);
      }

      if (item.variavel) {
        await this.carregarCombinacoesAjusteEstoque(item);
      }
    },
    async carregarLotesAjusteEstoque(item) {
      try {
        const { data } = await this.$http.post("/produtos/get-lote", {
          id_produto: item.id_produto,
          compra: true,
        });

        item.lotes = [{ value: null, text: "Selecione" }].concat(
          (data || []).map((lote) => ({
            value: lote.id_produto_lote,
            text: `${lote.numero_lote} - QTD: ${this.numberToReal(lote.quantidade, "quantidade")}`,
            quantidade: Number(lote.quantidade || 0),
            numero_lote: lote.numero_lote,
          }))
        );
      } catch (error) {
        console.log(error);
        this.$toast.error("Erro ao carregar lotes do produto.");
      }
    },
    async carregarCombinacoesAjusteEstoque(item) {
      try {
        const { data } = await this.$http.post("/produtos/get-combinacao", {
          id_produto: item.id_produto,
        });

        item.combinacoesRaw = data?.combinacao || [];
        item.combinacoes = [{ value: null, text: "Selecione" }].concat(
          item.combinacoesRaw.map((combinacao, index) => ({
            value: index,
            text: `${this.formatarCombinacaoAjusteEstoque(combinacao)} - QTD: ${this.numberToReal(combinacao.quantidade, "quantidade")}`,
            quantidade: Number(combinacao.quantidade || 0),
          }))
        );
      } catch (error) {
        console.log(error);
        this.$toast.error("Erro ao carregar variações do produto.");
      }
    },
    formatarCombinacaoAjusteEstoque(combinacao) {
      return Object.keys(combinacao)
        .filter((key) => key !== "quantidade")
        .map((key) => combinacao[key])
        .join(" / ");
    },
    getQuantidadeBaseAjusteEstoque(item) {
      if (item.lote) {
        const lote = item.lotes.find((l) => l.value === item.id_produto_lote);
        return Number(lote?.quantidade || 0);
      }

      if (item.variavel) {
        const combinacao = item.combinacoesRaw[item.combinacaoIndex];
        return Number(combinacao?.quantidade || 0);
      }

      return Number(item.quantidadeAtual || 0);
    },
    getQuantidadeInformadaAjusteEstoque(item) {
      if (this.ajusteEstoqueRapido && item.marcado) {
        return this.ajusteEstoqueRapidoQuantidade;
      }

      return item.quantidade;
    },
    resultadoAjusteEstoque(item) {
      const quantidade = Number(
        this.getQuantidadeInformadaAjusteEstoque(item) || 0
      );
      const atual = this.getQuantidadeBaseAjusteEstoque(item);

      if (this.ajusteEstoqueOperacao === "saida") {
        return atual - quantidade;
      }

      if (this.ajusteEstoqueOperacao === "ajuste") {
        return quantidade;
      }

      return atual + quantidade;
    },
    classeResultadoAjusteEstoque(item) {
      const resultado = this.resultadoAjusteEstoque(item);

      if (resultado < 0) return "text-danger";
      if (this.ajusteEstoqueOperacao === "saida") return "text-warning";
      if (this.ajusteEstoqueOperacao === "ajuste") return "text-primary";
      return "text-success";
    },
    removerItemAjusteEstoque(index) {
      this.itensAjusteEstoque.splice(index, 1);
    },
    limparStatusItemAjusteEstoque(item, limpar) {
      if (!limpar) return;

      item.ajusteStatus = null;
      item.ajusteMensagem = null;
    },
    limparStatusItensMarcadosAjusteEstoque() {
      this.itensAjusteEstoqueMarcados.forEach((item) => {
        this.limparStatusItemAjusteEstoque(item, true);
      });
    },
    atualizarItemAjusteEstoqueAposSucesso(snapshot) {
      const { item, base, resultado, operacaoTexto } = snapshot;
      const diferenca = resultado - base;

      if (item.lote) {
        const loteIndex = item.lotes.findIndex(
          (lote) => lote.value === item.id_produto_lote
        );

        if (loteIndex >= 0) {
          const loteAtualizado = {
            ...item.lotes[loteIndex],
            quantidade: resultado,
          };

          loteAtualizado.text = `${loteAtualizado.numero_lote} - QTD: ${this.numberToReal(resultado, "quantidade")}`;
          this.$set(item.lotes, loteIndex, loteAtualizado);
        }

        item.quantidadeAtual = Number(item.quantidadeAtual || 0) + diferenca;
      } else if (item.variavel) {
        if (item.combinacoesRaw[item.combinacaoIndex]) {
          this.$set(
            item.combinacoesRaw[item.combinacaoIndex],
            "quantidade",
            resultado
          );
        }

        const combinacaoIndex = item.combinacoes.findIndex(
          (combinacao) => combinacao.value === item.combinacaoIndex
        );

        if (combinacaoIndex >= 0) {
          const combinacaoAtualizada = {
            ...item.combinacoes[combinacaoIndex],
            quantidade: resultado,
            text: `${this.formatarCombinacaoAjusteEstoque(item.combinacoesRaw[item.combinacaoIndex])} - QTD: ${this.numberToReal(resultado, "quantidade")}`,
          };

          this.$set(item.combinacoes, combinacaoIndex, combinacaoAtualizada);
        }

        item.quantidadeAtual = Number(item.quantidadeAtual || 0) + diferenca;
      } else {
        item.quantidadeAtual = resultado;
      }

      item.marcado = false;
      item.quantidade = null;
      item.ajusteStatus = "success";
      item.ajusteMensagem = `${operacaoTexto} aplicado com sucesso`;
    },
    validarItemAjusteEstoque(item) {
      if (!item.marcado) return true;
      const quantidade = this.getQuantidadeInformadaAjusteEstoque(item);
      if (!quantidade && quantidade !== 0) return false;
      if (Number(quantidade) < 0) return false;
      if (item.lote && !item.id_produto_lote) return false;
      if (item.variavel && item.combinacaoIndex === null) return false;
      return true;
    },
    montarPayloadAjusteEstoque() {
      return {
        operacao: this.ajusteEstoqueOperacao,
        itens: this.itensAjusteEstoque
          .filter((item) => item.marcado)
          .map((item) => ({
            id_produto: item.id_produto,
            quantidade: Number(this.getQuantidadeInformadaAjusteEstoque(item)),
            id_produto_lote: item.id_produto_lote || null,
            combinacao: item.variavel
              ? item.combinacoesRaw[item.combinacaoIndex]
              : null,
          })),
      };
    },
    async salvarAjusteEstoque() {
      const itensInvalidos = this.itensAjusteEstoque.filter(
        (item) => !this.validarItemAjusteEstoque(item)
      );

      if (itensInvalidos.length) {
        this.$toast.error("Revise os itens marcados antes de aplicar.");
        return;
      }

      const snapshots = this.itensAjusteEstoqueMarcados.map((item) => ({
        item,
        base: this.getQuantidadeBaseAjusteEstoque(item),
        resultado: this.resultadoAjusteEstoque(item),
        operacaoTexto: this.operacaoAjusteEstoqueTexto,
      }));

      this.addLoadingToButton("ajusteManualEstoqueBtn");
      try {
        await this.$http.post(
          "/produtos/ajuste-manual-estoque",
          this.montarPayloadAjusteEstoque()
        );

        snapshots.forEach((snapshot) => {
          this.atualizarItemAjusteEstoqueAposSucesso(snapshot);
        });
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$refs.produto.refresh();
      } catch (error) {
        console.log(error);
        this.$toast.error(
          error?.response?.data?.message || "Erro ao ajustar estoque!"
        );
      }
      this.removeLoadingToButton("ajusteManualEstoqueBtn");
    },
    limparAjusteEstoque() {
      this.ajusteEstoqueOperacao = "entrada";
      this.ajusteEstoqueRapido = false;
      this.ajusteEstoqueRapidoQuantidade = null;
      this.produtoSelecionadoAjusteEstoque = null;
      this.produtosAjusteEstoque = [];
      this.itensAjusteEstoque = [];
    },
    ehCampoComLooku() {
      if (!this.campoSelecionadoReplicacao) return false;
      const campo = this.camposDisponiveis.find(c => c.value === this.campoSelecionadoReplicacao);
      return campo?.comLookup === true;
    },
    obterTipoCampo() {
      if (!this.campoSelecionadoReplicacao) return "text";
      const campo = this.camposDisponiveis.find(c => c.value === this.campoSelecionadoReplicacao);
      return campo?.tipo === "number" ? "number" : "text";
    },
    abrirModalReplicarCampo() {
      // Modo 1: Estoque total (aplica para todos)
      if (this.modoReplicacao === "todos") {
        this.produtoOrigemReplicacao = null;
        this.produtosDestinoReplicacao = [];
        this.campoSelecionadoReplicacao = null;
        this.valorCampoReplicacao = null;
        this.$bvModal.show("replicarCampoMassa");
        return;
      }

      // Modo 2: Produtos selecionados
      if (!this.actionsStore.selectedRows || this.actionsStore.selectedRows.length < 1) {
        this.$toast.error("Selecione pelo menos 1 produto!");
        return;
      }

      // Se tiver 1+ produtos selecionados, abre modal
      this.produtoOrigemReplicacao = this.actionsStore.selectedRows[0];
      this.produtosDestinoReplicacao = this.actionsStore.selectedRows.slice(1);
      this.campoSelecionadoReplicacao = null;
      this.valorCampoReplicacao = null;
      this.searchLookupValue = "";
      this.resultadosLookup = [];
      this.selecionadoItem = null;

      this.$bvModal.show("replicarCampoMassa");
    },
    resetarValorCampoReplicacao() {
      this.valorCampoReplicacao = null;
      this.resultadosLookup = [];
      this.selecionadoItem = null;
    },
    setSelecionadoItem(item) {
      this.selecionadoItem = item;
    },
    
    // Obtém o ID correto baseado no campo e estrutura do item
    obterIdDoItem(item, campo) {
      if (!item) return null;
      
      // Mapeamento customizado por campo
      switch(campo) {
        case "id_pessoa":
          return item.id_pessoa || item.id;
        case "id_grupo":
          return item.id_grupo || item.id;
        case "id_tributacao":
        case "id_tributacao_st":
          return item.id_tributacao || item.id;
        case "id_medida":
          return item.id_medida || item.id;
        case "id_ncm":
          return item.id_ncm || item.id;
        case "id_origem":
          return item.id_origem || item.id;
        case "id_cfop":
        case "id_cfop_nfce":
          return item.id_cfop || item.id;
        case "id_cest":
          return item.id_cest || item.id;
        case "id_cst_csosn":
        case "id_cst_csosn_contribuinte":
          return item.id_cst_csosn || item.id_cst || item.codigo || item.id;
        case "id_perfil_tributario":
          return item.id;
        default:
          return item.id || item.id_pessoa || item.codigo;
      }
    },
    
    handleSearchDinamico(search, loading) {
      if (!this.campoSelecionadoReplicacao || search.length < 2) {
        this.resultadosLookup = [];
        if (loading) loading(false);
        return;
      }

      if (loading) loading(true);
      this.executarBuscaDinamica(search, loading);
    },

    // Executa a busca com base no campo selecionado
    executarBuscaDinamica: _.debounce(async function(search, loading) {
      try {
        const campo = this.campoSelecionadoReplicacao;
        let dados = [];

        switch(campo) {
          case "id_grupo":
            dados = await this.getGrupoByDescricao(search);
            break;
          case "id_pessoa":
            dados = await this.getFornecedorByNome(search);
            break;
          case "id_tributacao":
          case "id_tributacao_st":
            dados = await this.getTributacaoByDescricao(search);
            break;
          case "id_medida":
            dados = await this.getUNByDescricao(search);
            break;
          case "id_ncm": {
            const allNCM = await this.getNCM();
            dados = Array.isArray(allNCM) ? allNCM.filter(item => {
              const label = (item.codigo || item.descricao || '').toString().toLowerCase();
              return label.includes(search.toLowerCase());
            }) : [];
            break;
          }
          case "id_origem": {
            // Usar lista estática e filtrar localmente
            const searchLower = String(search).toLowerCase().trim();
            dados = this.origens.filter(item => {
              const descricao = String(item.descricao).toLowerCase();
              const id = String(item.id);
              return descricao.includes(searchLower) || id.includes(searchLower);
            });
            break;
          }
          case "id_anp":
            dados = await this.getAnpByCodigo(search);
            break;
          case "id_cenq":
            dados = await this.getCenqByCodigo(search);
            break;
          case "id_cest":
            dados = await this.getCESTByCodigo(search);
            break;
          case "id_cfop":
          case "id_cfop_nfce":
            dados = await this.getCFOPByCodigo(search);
            break;
          case "id_cst_csosn":
          case "id_cst_csosn_contribuinte": {
            dados = await this.getCstCsosn();
            // Filtrar localmente para CST
            dados = dados.filter(item => {
              const label = item.codigo || item.descricao || JSON.stringify(item);
              return label.toLowerCase().includes(search.toLowerCase());
            });
            break;
          }
          case "id_perfil_tributario":
            dados = await this.getPerfilTributarioByDescricao(search);
            break;
          default:
            dados = [];
        }

        // Mapear para formato esperado pelo v-select
        this.resultadosLookup = (Array.isArray(dados) ? dados : []).map(item => {
          let label;
          
          // Formatar label específico por tipo de campo
          if (this.campoSelecionadoReplicacao === "id_cst_csosn" || 
              this.campoSelecionadoReplicacao === "id_cst_csosn_contribuinte" ||
              this.campoSelecionadoReplicacao === "id_cest" ||
              this.campoSelecionadoReplicacao === "id_cfop" ||
              this.campoSelecionadoReplicacao === "id_cfop_nfce") {
            label = item.codigo ? `${item.codigo} - ${item.descricao}` : item.descricao;
          } else {
            label = item.descricao || item.nome || item.codigo || JSON.stringify(item);
          }
          
          return {
            value: this.obterIdDoItem(item, this.campoSelecionadoReplicacao),
            label: label,
            ...item
          };
        });

      } catch (error) {
        console.log("Erro ao buscar:", error);
        this.resultadosLookup = [];
      }

      if (loading) loading(false);
    }, 350),
    validarValorCampo() {
      if (!this.campoSelecionadoReplicacao) return false;
      
      // Para campos com lookup, precisa ter item selecionado
      if (this.ehCampoComLooku()) {
        return this.selecionadoItem !== null;
      }
      
      // Para campos normais, precisa ter valor
      return this.valorCampoReplicacao !== null && this.valorCampoReplicacao !== "";
    },
    async executarReplicacaoCampo() {
      if (!this.campoSelecionadoReplicacao) {
        this.$toast.error("Selecione um campo válido!");
        return;
      }

      // Validar modo e seleção
      if (this.modoReplicacao === "selecionados" && this.produtosDestinoReplicacao.length === 0 && this.produtoOrigemReplicacao === null) {
        this.$toast.error("Selecione ao menos 1 produto!");
        return;
      }

      // Obter valor a replicar
      let valor;
      if (this.ehCampoComLooku()) {
        if (!this.selecionadoItem) {
          this.$toast.error("Selecione um valor do campo!");
          return;
        }
        valor = this.selecionadoItem.value;
      } else {
        if (!this.valorCampoReplicacao) {
          this.$toast.error("Digite um valor!");
          return;
        }
        valor = this.valorCampoReplicacao;
      }

      this.addLoadingToButton("replicarCampoMassaBtn");

      try {
        // Preparar payload com todos os produtos selecionados
        let produtos = [];
        if (this.modoReplicacao === "selecionados") {
          // Incluir origem + destinos
          if (this.produtoOrigemReplicacao) {
            produtos.push({ id_produto: this.produtoOrigemReplicacao.id });
          }
          produtos = produtos.concat(
            this.produtosDestinoReplicacao.map((prod) => ({ id_produto: prod.id }))
          );
        }

        let payload = {
          campo: this.campoSelecionadoReplicacao,
          valor: valor,
          estoque_total: this.modoReplicacao === "todos",
          produtos: produtos
        };

        const { data } = await this.$http.post("/produtos/atualizar-em-massa", payload);

        const qtd = this.modoReplicacao === "todos" 
          ? "todos os produtos" 
          : `${produtos.length} produto(s)`;
        
        this.$toast.success(data.message || `Campo atualizado em ${qtd}!`);
        
        // Atualizar tabela
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$refs.produto.refresh();
        
        // Limpar e fechar
        this.fecharModalReplicacao();
      } catch (error) {
        console.log(error);
        this.$toast.error(
          error?.response?.data?.message || "Erro ao atualizar campo!"
        );
      }

      this.removeLoadingToButton("replicarCampoMassaBtn");
    },
    fecharModalReplicacao() {
      this.modoReplicacao = "selecionados";
      this.campoSelecionadoReplicacao = null;
      this.valorCampoReplicacao = null;
      this.produtoOrigemReplicacao = null;
      this.produtosDestinoReplicacao = [];
      this.resultadosLookup = [];
      this.selecionadoItem = null;
      this.actionsStore.selectedRows = [];
      this.$bvModal.hide("replicarCampoMassa");
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    allFields() {
      return [...this.fields, ...this.extraFields];
    },
    config() {
      return this.layoutConfig();
    },
    produtoParaDuplicar() {
      return (
        this.produtoDuplicarAcao || this.actionsStore?.selectedRows[0] || null
      );
    },
    itensAjusteEstoqueMarcados() {
      return this.itensAjusteEstoque.filter((item) => item.marcado);
    },
    operacaoAjusteEstoqueTexto() {
      const operacao = this.opcoesAjusteEstoque.find(
        (item) => item.value === this.ajusteEstoqueOperacao
      );

      return operacao?.text || "Entrada";
    },
    podeSalvarAjusteEstoque() {
      return (
        this.itensAjusteEstoqueMarcados.length > 0 &&
        this.itensAjusteEstoqueMarcados.every((item) =>
          this.validarItemAjusteEstoque(item)
        )
      );
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
</script>

<style scoped>
.ajuste-estoque-toolbar-btn {
  border: 1px solid #dbe7ff;
  box-shadow: 0 6px 16px rgba(54, 92, 245, 0.08);
  gap: 6px;
  min-height: 35px;
  padding-left: 14px;
  padding-right: 14px;
}

.ajuste-estoque-panel {
  background: #fbfcff;
  border: 1px solid #e8edf6;
  border-radius: 8px;
  padding: 20px;
}

.ajuste-estoque-count {
  background: #eef4ff;
  border: 1px solid #dce8ff;
  border-radius: 6px;
  color: #3152c8;
  font-size: 0.82rem;
  font-weight: 700;
  padding: 7px 10px;
  white-space: nowrap;
}

.ajuste-estoque-operacoes {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ajuste-estoque-operacoes ::v-deep .btn {
  border-radius: 6px !important;
  margin: 0 !important;
  min-width: 96px;
}

.ajuste-estoque-rapido {
  background: #fff;
  border: 1px solid #e8edf6;
  border-radius: 8px;
  padding: 12px;
}

.ajuste-estoque-table {
  border: 1px solid #e8edf6;
  border-radius: 8px;
  overflow: hidden;
}

.ajuste-estoque-table thead th {
  background: #fbfcff !important;
  color: #7e8299;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}

.ajuste-estoque-table tbody tr {
  background: #fff;
}

.ajuste-estoque-table tbody tr.ajuste-estoque-row-success {
  background: #f3fff8;
}

.ajuste-estoque-table tbody tr.ajuste-estoque-row-success td:first-child {
  border-left: 3px solid #1bc56d;
}

.ajuste-estoque-table tbody td {
  border-top-color: #eef2f7;
  vertical-align: middle;
}

.ajuste-estoque-tags {
  align-items: center;
  display: flex;
  gap: 6px;
  margin-top: 4px;
}

.ajuste-estoque-resultado {
  border-radius: 6px;
  display: inline-block;
  font-weight: 800;
  min-width: 84px;
  padding: 5px 8px;
  text-align: right;
}

.ajuste-estoque-resultado.text-success {
  background: #e9fbf0;
}

.ajuste-estoque-resultado.text-warning {
  background: #fff7e6;
}

.ajuste-estoque-resultado.text-primary {
  background: #edf3ff;
}

.ajuste-estoque-resultado.text-danger {
  background: #fff1f1;
}
</style>

<style>
.produto-acoes-popover {
  max-width: 240px;
  min-width: 220px;
}

.produto-acoes-popover .popover-body {
  padding: 0.35rem 0;
}

.produto-acoes-popover .dropdown-item {
  align-items: center;
  display: flex;
  min-height: 36px;
}
</style>
